import { z } from 'zod'
import {
  CustomerSessionEvent,
  CustomerSessionStatus,
} from '../constants/customerSession'
import { dbEntitySchema } from './system'

const customerSessionPageContextSchema = z.object({
  pathname: z.string().optional(),
  search: z.string().optional(),
  hash: z.string().optional(),
  referrer: z.string().optional(),
  title: z.string().optional(),
  href: z.string().optional(),
  protocol: z.string().optional(),
  host: z.string().optional(),
  hostName: z.string().optional(),
  port: z.string().optional(),
})

const customerSessionUserAgentContextSchema = z.object({
  full: z.string().optional().nullable(),
  browserName: z.string().optional().nullable(),
  browserVersion: z.string().optional().nullable(),
  deviceModel: z.string().optional().nullable(),
  deviceType: z.string().optional().nullable(),
  deviceVendor: z.string().optional().nullable(),
  osName: z.string().optional().nullable(),
  osVersion: z.string().optional().nullable(),
  engineName: z.string().optional().nullable(),
  engineVersion: z.string().optional().nullable(),
  cpuArchitecture: z.string().optional().nullable(),
})

export const customerSessionContextSchema = z.object({
  page: customerSessionPageContextSchema.optional(),
  userAgent: z
    .union([z.string(), customerSessionUserAgentContextSchema])
    .optional(),
})

export const customerSessionSchema = dbEntitySchema.extend({
  organization: z.string(),
  venue: z.string(),
  customer: z.string(),
  sessionId: z.string(),
  admissionGroup: z.string().optional(),
  admissionGroupType: z.string().optional(),
  order: z.string().optional(),
  startedOn: z.date().optional(),
  endedOn: z.date().optional(),
  lastUpdatedOn: z.date().optional(),
  status: z.nativeEnum(CustomerSessionStatus),
  reservationRequested: z.boolean().optional(),
  reservationRequestedDate: z.date().optional(),
  guestlistRequested: z.boolean().optional(),
  guestlistRequestedDate: z.date().optional(),
  cartStarted: z.boolean().optional(),
  cartStartedDate: z.date().optional(),
  checkoutStarted: z.boolean().optional(),
  checkoutStartedDate: z.date().optional(),
  orderCompleted: z.boolean().optional(),
  orderCompletedDate: z.date().optional(),
  orderAbandoned: z.boolean().optional(),
  orderAbandonedDate: z.date().optional(),
  ipAddress: z.string().optional(),
  context: customerSessionContextSchema.optional(),
})

export const customerSessionCreateOrUpdateByTrackArgsSchema = z.object({
  trackId: z.string(),
})

export const customerSessionEventPayloadSchema = z.object({
  id: z.string(),
})

export const customerSessionEventSchema = z.nativeEnum(CustomerSessionEvent)
